<template>
  <div class="flex flex-col w-full justify-start items-center px-2">
    <span>Groups:</span>
    <div class="flex flex-col w-full">
      <div
        v-for="index in displayData"
        :key="index">
        <div class="flex flex-row bg-gray-200 rounded-md h-8 justify-center items-center">
          <select class="w-3/4 h-6 text-xs mr-1 border-grey-500 rounded-md border-2"
            v-model="formValues[index]">
            <option v-if="formValues[index]">
              {{ formValues[index] }}
            </option>
            <option v-for="userGroup in remainingUserGroupOptions"
              :key="userGroup"
              :value="userGroup">
              {{ userGroup }}
            </option>
          </select>
          <XButton class="bg-orange-200 p-1 w-4 h-4"
            @click="deleteGroup(index)"
          />
        </div>
      </div>
      <Button
        color="blue"
        :disabled="!enableAddGroup"
        @click="addGroup">Add</Button>
    </div>
  </div>
</template>

<script>
import Button from '../../components/Button.vue'
import XButton from '../../components/XButton.vue'


export default {
  components: {
    Button,
    XButton,
  },
  props: {
    userGroupOptions: Array,
    enableAddGroup: {
      type: Boolean,
      default: true,
    },
    value: undefined,
    defaultValue: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      formValues: [],
    }
  },
  mounted() {
    if (this.defaultValue !== undefined) {
      this.formValues = this.defaultValue
    }
  },
  methods: {
    deleteGroup(index) {
      this.formValues.splice(index, 1)
    },
    addGroup() {
      if (this.formValues === undefined) {
        this.$set(this, 'formValues', [])
      }
      this.formValues.push('')
    },
    updateValue() {
      this.$emit('input', this.formValues)
    },
  },
  computed: {
    displayData() {
      if (this.formValues === undefined) {
        return []
      }

      return this.formValues.map((elem, index) => index)
    },
    remainingUserGroupOptions() {
      return this.userGroupOptions.filter(userGroup => !this.formValues.includes(userGroup))
    }
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    formValues() {
      this.updateValue()
    },
    defaultValue(newValue) {
      this.formValues = newValue
    }
  }
}
</script>
